import styled, { css } from 'styled-components';
const DropdownOptionWrapper = styled.div `
  border-radius: 6px;
  margin-top: ${({ optionMarginTop }) => optionMarginTop || '0.25rem'};
  box-shadow: 0 1px 2px 1px ${({ theme }) => theme.colors.SHADOW_DEFAULT};
  z-index: 2;
  position: absolute;
  visibility: hidden;
  min-width: ${({ width }) => width};
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  ${({ optionMaxHight }) => optionMaxHight ? `max-height: ${optionMaxHight};` : ''}
  overflow: hidden;
  ${props => props.menuAlign === 'left' &&
    css `
      left: 0;
    `};

  ${props => props.menuAlign === 'right' &&
    css `
      right: 0;
    `};

  ${props => props.menuAlign === 'center' &&
    css `
      left: 50%;
      transform: translateX(-50%);
    `};

  ${props => props.isOpen === true &&
    css `
      visibility: initial;
      overflow: auto;
    `};
`;
export default DropdownOptionWrapper;
//# sourceMappingURL=DropdownOptionWrapper.js.map